import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from "react";
import { withStyles } from "@material-ui/core";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
import Fade from "@material-ui/core/Fade";
import { muiTheme, commonArrowStyles, arrowGenerator } from "./styles";
var styles = {
  popper: _extends({
    zIndex: 99998,
    // keep always consistent with formula popover and name tooltip
    margin: "10px 0"
  }, arrowGenerator(muiTheme.palette.background.paper)),
  arrow: _extends({}, commonArrowStyles, {
    fontSize: 7,
    width: "3em",
    height: "3em"
  })
};

var FormulaPopover = function (_Component) {
  _inherits(FormulaPopover, _Component);

  function FormulaPopover() {
    var _temp, _this, _ret;

    _classCallCheck(this, FormulaPopover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      arrowRef: null
    }, _this.handlePopperArrowRef = function (el) {
      _this.setState({
        arrowRef: el
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FormulaPopover.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        _props$renderChildren = _props.renderChildren,
        renderChildren = _props$renderChildren === undefined ? function () {
      return null;
    } : _props$renderChildren,
        classes = _props.classes,
        _props$placement = _props.placement,
        placement = _props$placement === undefined ? "bottom" : _props$placement,
        children = _props.children,
        rest = _objectWithoutProperties(_props, ["renderChildren", "classes", "placement", "children"]);

    var arrowRef = this.state.arrowRef;
    return React.createElement(Popper, _extends({
      className: classes.popper,
      placement: placement,
      disablePortal: false,
      modifiers: {
        flip: {
          enabled: true
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: "scrollParent"
        },
        arrow: {
          enabled: true,
          element: arrowRef
        }
      },
      transition: true
    }, rest), function (_ref) {
      var TransitionProps = _ref.TransitionProps;
      return React.createElement(Fade, _extends({}, TransitionProps, {
        timeout: 350
      }), React.createElement("div", null, React.createElement("span", {
        className: classes.arrow,
        ref: _this2.handlePopperArrowRef
      }), React.createElement(Paper, {
        elevation: 3
      }, children || renderChildren())));
    });
  };

  return FormulaPopover;
}(Component);

export default withStyles(styles)(FormulaPopover);